@use '@/styles/mastodon/mixins';

.modal {
  @include mixins.elevation-1;

  border-radius: var(--radius-6);
  box-sizing: border-box;
  background: var(--color-bg-primary);
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: var(--space-4);
  pointer-events: auto;
  user-select: text;
  overflow: hidden;
}

.modalMaxWidth {
  width: 100%;
}

.modalElevated {
  @include mixins.elevation-2;
}

.titleWrapper {
  display: flex;
  align-items: start;
  gap: var(--space-4);
}

.title {
  @include mixins.type-heading-sm;

  flex: 1 1 auto;
}

.closeButton {
  // Prevent close button from increasing spacing around title
  margin-block: calc(-1 * var(--space-2));
  margin-inline-end: calc(-1 * var(--space-2));
}

.actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
}

.actionsLeft {
  justify-content: flex-start;
}

.actionsRight {
  justify-content: flex-end;
}

.actionsVertical {
  flex-direction: column;
  align-items: stretch;
}
